import { Box, Typography } from "@mui/material";

import { styles } from "./InfoBanner-styles";

export type InfoBannerProps = {
  title: string;
  description: string;
};

export const InfoBanner = ({ title, description }: InfoBannerProps) => {
  return (
    <Box sx={styles.infoBanner}>
      <Typography variant="body1" data-test="infoBannerTitle">
        {title}
      </Typography>
      <Typography variant="body2" maxWidth="75%" data-test="infoBannerDescription">
        {description}
      </Typography>
    </Box>
  );
};
